import UserManage from './UserManage';

export default UserManage;
